export enum EAplicacaoRegraFrete {
    AcrescimoValor = 1,
    AcrescimoPercentual = 2,
    ValorFixo = 3,
    DescontoValor = 4,
    DescontoPercentual = 5,
    PrazoAdicional = 6,
}
